import React, { useCallback, useRef, useState } from 'react'
import {
    createColumnHelper,
    getCoreRowModel,
    useReactTable,
    getSortedRowModel
} from '@tanstack/react-table'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { Button, Dropdown, Form, InputGroup, Modal } from 'react-bootstrap'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import ReactTable from '../../components/ReactTable'
import Pagination from '../../components/Pagination'
import requestApi from '../../utils/request'
import { formatDateToMonthShortwithFormate } from '../../functions/common'
import Swal from 'sweetalert2'
import { ReactComponent as Eyes } from '../../assets/images/teyes.svg'
import { ReactComponent as Edit } from '../../assets/images/tedit.svg'
import { ReactComponent as Delete } from '../../assets/images/tdelete.svg'
import { ReactComponent as DeleteImg } from '../../assets/images/redbin.svg'
import { ReactComponent as SearchIcon } from '../../assets/images/greysearch.svg'
import { ReactComponent as FilterIcon } from '../../assets/images/filter.svg'
import { employerview, jobopeningview } from '../../Routes/routingConsts'
import DropDownControl from '../../components/DropDownControl/DropDownControl'
import SpinnerLoader from '../../components/SpinnerLoader'
import { Spinner } from 'react-bootstrap'
import { useEffect } from 'react'
import {
    deleteActionIcon,
    viewIcon,
    editactionIcon
} from '../../functions/actionIcons'
import FlottedButton from '../../components/FlottingButton'
import ButtonWithLoader from '../../components/ButtonWithLoader/ButtonWithLoader'
import InputControl from '../../components/InputControl/InputControl'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import ckeditor, { CKEditor } from '@ckeditor/ckeditor5-react'

const Compliance = () => {
    const navigate = useNavigate()
    const [ckeditordata, setckeditordata] = useState('')
    const [toggle, setToggle] = useState(null)
    const queryClient = useQueryClient()
    const [DataLimit, setDataLimit] = useState(10)
    const [editValueID, setEditValueID] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    // const [TotalPagies, setTotalPagies] = useState(1)
    const EditDataRef = useRef(null)
    const [userFilterText, setuserFilterText] = useState('')
    const handleChange2 = (e) => {
        setCurrentPage(1)
        const getData = setTimeout(() => {
            setuserFilterText(e.target.value)
        }, 1000)
        clearInterval()
    }

    const handleChange = (eventkey) => {
        setDataLimit(eventkey)
    }

    function editjobopening(categoryItem) {
        console.log(categoryItem)
        setShowAdd(true)
        for (const key in categoryItem) {
            setValue(key,categoryItem[key])
        }
        setEditCategoryId(categoryItem.complianceId)
        // console.log(categoryItem, 'categoryItem')
        // setAddCategoryValue(categoryItem.categoryName)
    }

    /////status filter////
    const [statusControl, setStatusControl] = useState('')
    const handleChangeStatus = (eventKey) => {
        setCurrentPage(1)
        setStatusControl(eventKey)
    }

    const compliancevalidation = yup.object({
        complianceName: yup.string().max(45,"Maximum charactor is 45").nullable().trim().required('Please enter compliance name.'),
        description: yup
            .string().nullable()
            .trim()
            .required('Please enter compliance description'),
    })

    const {
        control,
        register,
        watch,
        clearErrors,
        handleSubmit,
        reset,
        setError,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(compliancevalidation),
        shouldUnregister: true,
      
    })

    const [sorting, setSorting] = useState([])

    function UserList({ queryKey }) {
        return requestApi
            .post(
                `/compliance/list`,
                {
                    search: queryKey[3],
                    limit: queryKey[2],
                    page: queryKey[1],
                    sortKey: queryKey[4]?.id ?? '',
                    sortBy: queryKey[4] ? (queryKey[4]?.desc ? -1 : 1) : '',
                    status: statusControl
                },
                { headers: true }
            )
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: [
            'jobOpeninglist',
            currentPage,
            DataLimit,
            userFilterText,
            sorting[0],
            statusControl
        ],
        queryFn: UserList
        // select: () => {
        //     return {
        //         data: null
        //     }
        // }
    })

    //View Data
    const [showViewModal, setShowViewModal] = useState(false)
    const [viewData, setViewData] = useState('');
    console.log('viewData', viewData)

    const viewComplianceData = (ViewData) => {
        setViewData(ViewData)
        setShowViewModal(true)
    }


    let totalJobOpening = data?.meta?.totalCount

    const handleChangePage = useCallback(
        (currentPage) => {
            setCurrentPage(currentPage)
        },
        [currentPage]
    )

    const columnHelper = createColumnHelper()
    const columns = [
        columnHelper.display({
            id: 'actions',
            header: 'Action',
            cell: (row) => {
                return (
                    <>
                        <div className="">
                            <FlottedButton
                                clickFn={() => {
                                    setToggle((pre) =>
                                        pre === row.row.original?.complianceId
                                            ? null
                                            : row.row.original?.complianceId
                                    )
                                }}
                                isTrue={
                                    row.row.original?.complianceId === toggle
                                }
                            >
                                {row.row.original.status === 3
                                    ? ''
                                    : <li
                                        className=" i1 icon"
                                        onClick={() =>
                                         viewComplianceData(
                                          row.row.original
                                        )
                                         }
                                     >
                                          {viewIcon}
                                       </li>
                                      }
                                <li
                                    className=" i1 icon"
                                    onClick={() => {
                                        editjobopening(row.row.original)
                                    }}
                                >
                                    {editactionIcon}
                                </li>
                                {/* <Link
                                    to={`/createnewopening/${row?.row?.original?.userId}`}
                                >
                                    <button
                                        className="action-btn"
                                        onClick={() =>
                                            editjobopening(
                                                row.row.original?.categoryId
                                            )
                                        }
                                    >
                                        <span>
                                            <Edit />
                                        </span>
                                    </button>
                                </Link> */}
                                {row.row.original.status === 3 ? (
                                    ''
                                ) : (
                                    <li
                                        className=" i1 icon"
                                        onClick={() =>
                                            hanleDeleteModal(
                                                row.row.original?.complianceId
                                            )
                                        }
                                    >
                                        {deleteActionIcon}
                                    </li>
                                )}
                            </FlottedButton>
                        </div>
                    </>
                )
            }
        }),

        columnHelper.accessor((row) => row.complianceName, {
            id: 'complianceName',
            header: 'Name',
            cell: (row) => {
                return <p>{row.row.original?.complianceName}</p>
            }
        })
    ]

    // useEffect while record deleted on last page ////
    useEffect(() => {
        if (currentPage && data?.data?.length == 0) {
            setCurrentPage(1)
        } else {
        }
    }, [currentPage, data?.data])

    // End useEffect ////

    const tableInstance = useReactTable({
        data: data?.data,
        columns: columns,
        state: {
            sorting
        },
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        getCoreRowModel: getCoreRowModel()
    })

    //Add or Edit User
    const [showAdd, setShowAdd] = useState(false)
    const [addCategoryValue, setAddCategoryValue] = useState('')
    const [editCategoryId, setEditCategoryId] = useState('');
    // console.log('editCategoryId',)

    // console.log('addCategoryValue', addCategoryValue)

    async function addCatagoryId({ ...payload }) {
       
            return await requestApi.post(`/compliance/add-edit`, {
                ...payload,
            })
            .then((res) => {
                return res.data
            })
        
    }

    const mutationAddEdit = useMutation(addCatagoryId, {
        onSuccess: ({ data }) => {
            reset()
            queryClient.invalidateQueries('jobOpeninglist')
            setValue("complianceName","4545454")
            setShowAdd(false)
            setValue("complianceId",null)
            
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    const handleAddEditCompliance = () => {
        mutationAddEdit.mutate(addCategoryValue)
        setShowAdd(false)
    }

    // Delete Complinace
    const [showDelete, setShowDelete] = useState(false)
    const [deletedId, setDeletedId] = useState(null)

    async function deletecategoryId(complianceId) {
        return await requestApi.post(`/compliance/delete`, {
            complianceId
        })
    }
    const mutationDelete = useMutation(deletecategoryId, {
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries('jobOpeninglist')
            setShowDelete(false)
            EditDataRef.current = null
        },
        onError: (error) => {
            EditDataRef.current = null
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })

    const hanleAddModal = () => {
        setShowAdd(true)
    }
    const hanleDeleteModal = (complianceId) => {
        setShowDelete(true)
        setDeletedId(complianceId)
    }
    const handleDeleteUser = (complianceId) => {
        mutationDelete.mutate(complianceId)
        setShowDelete(false)
    }

    const handleCompliance=(data)=>{

     const {complianceId,...rest}=data
     if (complianceId) {
        mutationAddEdit.mutate({complianceId,...rest})
     }else{

         mutationAddEdit.mutate(rest)
     }
     setEditCategoryId('')
    }

    return (
        <>
            <div className="sidebar-content common-page">
                <div className="contentwhole-box details-box">
                    <div className="filter-titlebox">
                        <div className="title-text">
                            <h3>Compliance</h3>
                        </div>
                        <div className="filterbox">
                            <div className="searcskills myaccount-page">
                                <div>
                                    <div className="searchstatus-box">
                                        <InputGroup className="mb-3 input-wrapper">
                                            <InputGroup.Text id="basic-addon1">
                                                <SearchIcon />
                                            </InputGroup.Text>
                                            <Form.Control
                                                placeholder="Search"
                                                type="search"
                                                aria-label="Username"
                                                aria-describedby="basic-addon1"
                                                className="icontrol"
                                                {...register(
                                                    'jobOpeningSearch',
                                                    {
                                                        onChange: (e) => {
                                                            handleChange2(e)
                                                        }
                                                    }
                                                )}
                                            />
                                        </InputGroup>
                                        <Button
                                            style={{padding: '0 10px', marginLeft: '20px', width: '100%'}}
                                            className="common-btn save-btn"
                                            onClick={() => hanleAddModal()}
                                        >
                                        + Add Compliance
                                        </Button>       
                                    </div>
                                </div>
                            </div>      
                        </div>
                    </div>

                    {isLoading ? (
                        <div className="spinner-wrapper">
                            <Spinner
                                animation="border"
                                role="status"
                                className="tdata"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        </div>
                    ) : (
                        <>
                            {' '}
                            {data?.data?.length > 0 ? (
                                <>
                                    <ReactTable tableInstance={tableInstance} />
                                    <div className="paginationbox">
                                        <div className="showingpages">
                                            <span>
                                                Showing{' '}
                                                {(currentPage - 1) * DataLimit +
                                                    1}{' '}
                                                to{' '}
                                                {Math.min(
                                                    currentPage * DataLimit,
                                                    totalJobOpening
                                                )}{' '}
                                                of {totalJobOpening} Compliances
                                            </span>
                                        </div>
                                        {totalJobOpening > 10 && <div className="itemsperpage">
                                            <span>Items per page:</span>
                                            <Dropdown
                                                flip="no"
                                                onSelect={handleChange}
                                            >
                                                <Dropdown.Toggle
                                                    variant="success"
                                                    id="dropdown-basic"
                                                >
                                                    {DataLimit}
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item eventKey="10">
                                                        10
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="20">
                                                        20
                                                    </Dropdown.Item>
                                                    <Dropdown.Item eventKey="30">
                                                        30
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>}
                                        {totalJobOpening > 10 && (
                                            <div className="pagination">
                                                <Pagination
                                                    total={Math.ceil(
                                                        totalJobOpening /
                                                            DataLimit
                                                    )}
                                                    current={currentPage}
                                                    onChangePage={
                                                        handleChangePage
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </>
                            ) : (
                                <div className="noresult">
                                    <p>No Result Found</p>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
            <Modal size="lg"
                style={{backdropFilter: 'blur(2px)'}}
                className="modalbox showAdd"
                show={showAdd}
                onHide={() => {
                    setEditCategoryId('')
                    setAddCategoryValue('')
                    setShowAdd(false)
                    setValue("complianceId",null)
                }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h3>{editCategoryId === '' ? 'Add Compliance' : 'Edit Compliance'}</h3>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Form onSubmit={handleSubmit(handleCompliance)}>
                            <InputControl
                                label="Name"
                                name="complianceName"
                                register={register}
                                autoFocus="true"
                                error={
                                    errors?.complianceName?.message
                                }
                            />
                            <div class="input-wrapper"><h3 class="lcontrol">Description</h3></div>
                            <div className="jobdesbox">
                                <div className="createnew-box">
                                    <Controller
                                        control={control && control}
                                        name={'description'}
                                        render={({
                                            field: {
                                                value,
                                                onChange: ckEditoronchange
                                            }
                                        }) => (
                                            <CKEditor
                                                data={value ??""}
                                                editor={ClassicEditor}
                                                config={{
                                                    removePlugins: [
                                                        'EasyImage',
                                                        'ImageUpload',
                                                        'MediaEmbed'
                                                    ],
                                                    link: {
                                                        addTargetToExternalLinks: true
                                                    }
                                                }}
                                                onReady={(editor) =>
                                                    // data?.data?.jobDescription
                                                    console.log(editor, 'hello')
                                                }
                                                onChange={(event, editor) => {
                                                    const data = editor.getData()
                                                    console.log(data)
                                                    ckEditoronchange(data)
                                                }}
                                            />
                                        )}
                                    />
                                    <span className="error-message">
                                        {errors.description?.message}
                                    </span>
                                </div>
                            </div>

                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <Button
                                type='submit'
                                    style={{ padding: '0 10px' }}
                                    className="common-btn save-btn"
                                    // onClick={() => handleAddEditCopliance()}
                                    // onClick={() => console.log("hsfgsjhdkj")}
                                >
                                    Submit
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal size="lg"
                style={{backdropFilter: 'blur(2px)'}}
                className="modalbox showAdd"
                show={showViewModal}
                onHide={() => {
                    setShowViewModal(false)
                    setEditCategoryId('')
                    setAddCategoryValue('')
                    setShowAdd(false)
                    setValue("complianceId",null)
                }}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <h3>View Compliance</h3>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <h4>Compliance Name :</h4>
                            <div style={{marginLeft: '10px'}}><p style={{fontSize: '18px'}}>{viewData?.complianceName}</p></div>
                        </div>
                        <div style={{marginTop: '10px'}}>
                            <h4>Description :</h4>
                                <div className='compliance-details' dangerouslySetInnerHTML={{__html:viewData?.description}}></div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                className="modalbox deletemodal"
                show={showDelete}
                onHide={() => setShowDelete(false)}
                backdrop="static"
                keyboard={false}
                style={{backdropFilter: 'blur(2px)'}}
            >
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <Form className="formbox">
                        <div className="delete-box">
                            <div className="deleteimg">
                                <DeleteImg />
                            </div>
                            <div className="content">
                                <h4>
                                    Are you sure you want to delete this <br />
                                    compliance?
                                </h4>
                            </div>
                            <div className="delete-action">
                                <button
                                    className="common-btn yes"
                                    type="button"
                                    onClick={() => handleDeleteUser(deletedId)}
                                >
                                    Yes
                                </button>
                                <button
                                    className="common-btn no"
                                    type="button"
                                    onClick={() => setShowDelete(false)}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Compliance
